<template>
    <div>
    <!-- add after this -->

    <!-- start breadbrumbs -->
		<div class="mt-4 mb-4">
			<nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/interhom/">Home</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/default.stm">Sustainability</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/building-energy-disclosure.stm">Building Energy Disclosure Project</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Registration</li>                   
                </ol>
			</nav>
		</div>
		<!-- end breadbrumbs -->
		<div class="row">
			<main class="col-12 col-lg-9">
			<div class="cw-content-nosidenav">
				<!-- ***** start custom content ***** -->
				<h1>Registration</h1>

                <h2 class="mb-4">Building information</h2>
                <div v-if="propertyInfo.length > 0" class="row">
                    <div class="col mb-5">
                        <h3>Previously added buildings:</h3>
                        <div class="row">
                            <div class="col-12 col-md-4 col-sm-6 mb-2" v-for="(p, index) in propertyInfo" :key="index">
                                <div class="card h-100">                    
                                    <div class="card-body">
                                        <h4 class="card-title" data-title="Property type">{{getPropertyName(propertyInfo[index])}}</h4>  
                                        <button @click="editProperty(index, p.index)" class="btn btn-secondary btn-sm mr-1">Edit</button>
                                        <button @click="deleteProperty(index)" class="btn btn-outline-secondary btn-sm">Delete</button>
                                    </div>                            
                                </div>
                            </div>
                        </div>                
                    </div>            
                </div>
                <div v-if="propertyInfo.length > 0" class="row">
                    <div class="col">
                        <h3>Add another building:</h3>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12 col-md-7">
                        <select id="propertytype" v-model="propertyType" name="LeaveType" @change="onChange($event)" class="form-control">
                            <option value="-1">Select building type</option>
                            <option v-for="(property, index) in propertyList" :value="index" :key="index">
                                {{ property[0].question }}
                            </option>
                        </select>
                    </div>
                </div>
                

                <div v-if="propertyType !== '-1'">
                    <div class="callout callout-info">
                        <h3>{{propertyName}}</h3>
                        <p>{{propertyDescription}}</p>                
                    </div>
                    <div v-if="!hasAccount">
                        <div v-for="(p, index) in propertyDetail" :key="index" class="form-row">
                            <div class="col-12 form-group" v-if="p.question !== propertyName && p.question !== propertyDescription">
                                <div v-if="radioButton[index] === '1'">
                                    <label><span class="question">{{p.question}} <a href="javascript:void(0);" @click="infoclicked(p.question)" class="small">(definition)</a></span></label>
                                </div>
                                <div v-if="radioButton[index] === '1'" class="custom-control custom-radio">
                                    <input type="radio" :id="'customRadio1' + index" :name="'customRadio' + index" value="Yes" v-model="p.answer" class="custom-control-input">
                                    <label class="custom-control-label" :for="'customRadio1' + index">Yes</label>
                                </div>
                                <div v-if="radioButton[index] === '1'" class="custom-control custom-radio">
                                    <input type="radio" :id="'customRadio2' + index" :name="'customRadio' + index" value="No" v-model="p.answer" class="custom-control-input" checked>
                                    <label class="custom-control-label" :for="'customRadio2' + index">No</label>
                                </div>
                                <div v-else>
                                    <label><span class="question">{{p.question}} <a href="javascript:void(0);" v-if="index > 3" @click="infoclicked(p.question)" class="small">(definition)</a></span></label>
                                    <div class="row">
                                        <div class="col-12 col-md-4"><input autocomplete="off" type="text" title="Click or tab here to enter text" v-model="p.answer" class="form-control form-control-md" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="col-12 col-md-4 form-group">
                                <label><span class="question">Building address</span></label>
                                <input autocomplete="off" type="text" title="Click or tab here to enter text" v-model="address" class="form-control form-control-md" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-4 form-group">
                                <label><span class="question">Postal code</span></label>
                                <input autocomplete="off" type="text" title="Click or tab here to enter text" v-model="postalCode" class="form-control form-control-md" />
                            </div>
                        </div>
                    </div>
                    <fieldset class="mt-4">
                        <legend>Portfolio Manager information</legend>
                        <div v-if="hasAccount">
                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label><span class="question">Portfolio Manager Username</span></label>
                                    <input autocomplete="off" type="text"  title="Click or tab here to enter text" v-model="pmUsername" class="form-control form-control-md" />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="form-row">
                                <div class="col form-group">
                                    <label><span class="question">How many physical buildings do you consider part of your property?</span></label>                            
                                    <div class="row">
                                        <div class="col-4 col-md-2">
                                            <input autocomplete="off" type="text" v-model="physicalBuilding"  title="Click or tab here to enter text" class="form-control form-control-md" />
                                        </div>
                                </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col form-group">
                                    <label><span class="question">Approximate Building Occupancy</span></label>
                                    <div class="row">
                                        <div class="col-6 col-md-3">
                                            <select v-model="buildingOccupancy" class="custom-select">
                                                <option></option>                                        
                                                <option>70% (minimum)</option>
                                                <option>80%</option>
                                                <option>90%</option>
                                                <option>100%</option>
                                            </select>
                                        </div>
                                </div>
                                </div>
                            </div>                   
                            <div class="row">                        
                                <div class="col form-group">
                                    <span class="font-weight-bold">My property energy consumption includes <a href="https://portfoliomanager.energystar.gov/pm/glossary#Parking" target="_blank">parking</a> area</span>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="parkingRadio1" v-model="parking" value="Yes" name="parkingRadio" class="custom-control-input">
                                        <label class="custom-control-label" for="parkingRadio1">Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="parkingRadio2" v-model="parking" value="No" name="parkingRadio" class="custom-control-input">
                                        <label class="custom-control-label" for="parkingRadio2">No</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 md-3 form-group">
                                    <label><span class="question">If yes, what is the parking gross floor area( sq. m)?</span></label>
                                    <input :disabled="parking !== 'Yes'" autocomplete="off" type="text" v-model="parkingGFA"  title="Click or tab here to enter text" class="form-control form-control-md" />
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12 md-3 form-group">
                                <label><span class="question">Additional building information (recent renovation, retrofit etc.)</span></label>                       
                                <textarea autocomplete="off" rows="3" class="form-control" v-model="additionalInfo"></textarea>
                            </div>
                        </div>
                    </fieldset>
                        

                    <!-- display account number -->            
                    <div v-if="propertyDetail.length > 0 & !hasAccount" class="mt-4">
                        <fieldset>
                            <legend>Manitoba Hydro account information</legend>
                            <p>List all active electric and natural gas meter numbers, and associated Manitoba Hydro account numbers.</p>

                            <div class="row">
                                <div class="col-12">
                                    <h3 class="h5">Previously added accounts:</h3>
                                </div>
                                <div class="col-12 col-md-6 mb-2" v-for="(a, index) in accountInfo" :key="index">
                                    <div class="card h-100">                    
                                        <div class="card-body">
                                            <p>Electric meter number: <span class="font-weight-bold">{{a.hydroNumber}}</span></p>                                    
                                            <p>Natural gas meter number: <span class="font-weight-bold">{{a.gasNumber}}</span></p>                                    
                                            <p for="accountNumber">Manitoba Hydro account number <span class="small">(14-digit)</span>: <span class="font-weight-bold">{{a.accountNumber}}</span></p>
                                            
                                            <button class="btn btn-outline-secondary btn-sm" @click="deleteHydro(index)">Delete</button>
                                        </div>                            
                                    </div>
                                </div>
                                <div class="col-12 mt-4">
                                    <h3 class="h5">Add another account:</h3>
                                </div>
                            </div>              
                            

                        
                            <div class="row mb-3">
                                <div class="col-12 col-sm-6">
                                    <label for="hydroNumber">Electric meter number</label>
                                    <input type="number" id="hydroNumber" v-model="hydroNumber" class="form-control form-control-md" />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-12 col-sm-6">
                                    <label for="gasNumber">Natural gas meter number</label>
                                    <input type="number" id="gasNumber" v-model="gasNumber" class="form-control form-control-md" />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-12 col-sm-6">
                                    <label for="accountNumber">Manitoba Hydro account number</label> <span class="small">(14-digit)</span>
                                    <input type="number" id="accountNumber" v-model="accountNumber" class="form-control form-control-md" />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-12 col-sm-6">
                                    <button id="cmdAddAccount" type="button" class="btn btn-light" @click="addAccountInfo">Add account information</button>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col mb-3 order-3 order-sm-1">
                        <button type="button" class="btn btn-outline-secondary" v-on:click.once="prevpage">Previous page</button>
                    </div>
                    <div class="col-md-auto mb-3 order-2">
                        <button type="button" class="btn btn-secondary justify-content-md-center" v-on:click="nextpage" v-if="propertyType != -1">{{button_label}}</button>
                    </div>
                    <div class="col-md-auto mb-3 order-1 order-sm-3">				
                        <button type="button" class="btn btn-primary" v-on:click="enablesummarypage">Next</button>
                    </div>
                </div>
            </div>
			</main>
		</div>

    <!-- add before this -->   
    </div>
</template>
<script>
    export default {
        data: function () {
            return {
                propertyType: '-1',
                propertyDetail: [],
                propertyName: '',
                propertyDescription: '',
                radioButton: [],
                propertyInfo: [],
                edit_data: false,
                button_label: "Add another building",
                accountInfo: [],
                accountNumber: '',
                hydroNumber: '',
                gasNumber: '',
                rowNumber: 0,
                hasAccount: false,
                pmUsername: "",
                physicalBuilding: "",
                buildingOccupancy: "",
                parking: "No",
                parkingGFA: "",
                additionalInfo: "",
                pageName: "View summary",
                summaryPage: false,
                address: "",
                postalCode: "",
            }
        },
        mounted() {
            this.$store.dispatch("GET_PROPERTY");
            this.$store.dispatch("GET_PROPERTYDETAIL");
            let hasAccount = (this.$store.getters.HASACCOUNT === 'true' || this.$store.getters.HASACCOUNT);
            if (hasAccount === "false" || hasAccount === false)
                hasAccount = false;
            this.hasAccount = hasAccount;
            
            this.summaryPage = this.$store.getters.SUMMARYPAGE;

            this.getPropertyInfo();

            if (!this.hasAccount && this.summaryPage === false)
                this.pageName = "Hydro agreement";
        },
        computed: {
            propertyList: function () {
                let data = this.$store.getters.PROPERTY;

                if (!data)
                    data[0][0] = { question: "", answer: "" };

                return data;
            },
        },
        methods: {
            deleteProperty(index) {
                this.propertyInfo.splice(index);
            },
            editProperty(index, value) {
                this.rowNumber = index;
                this.propertyType = value;
                let propertyList = this.$store.getters.PROPERTYLIST;
                let data = propertyList[index];
                //data.unshift( {question: data.propertydesc, answer: ""});
                //data.unshift( {question: data.propertytype, answer: ""});

                this.getPropertyDetail(data, index);

                this.edit_data = true;
                this.button_label = "Update building";
            },
            getPropertyDetail(data, index) {
                if (typeof (data) !== "undefined") {
                    this.propertyName = data.propertytype;
                    this.propertyDescription = data.propertydesc;

                    let temp = [];
                    temp.index = index;
                    temp.propertytype = data.propertytype;
                    temp.propertydesc = data.propertydesc;
                    temp.unshift({ question: data.propertydesc, answer: "" });
                    temp.unshift({ question: data.propertytype, answer: "" });

                    this.radioButton = [];
                    this.radioButton.push("0");
                    this.radioButton.push("0");
                    //insert specific questions.
                    for (var i = 2; i < data.length; i++) {
                        let yesNoQuestion = '0';
                        let question = data[i].question;
                        let answer = data[i].answer;
                        if (typeof (question) !== "undefined") {
                            if (question.indexOf("yes/no") > -1) {
                                yesNoQuestion = '1';

                                if (answer === "")
                                    answer = "No";
                            }

                            temp.push({ question: question, answer: answer });
                            this.radioButton.push(yesNoQuestion);
                        }
                    }
                    let item = data[data.length - 1];

                    this.accountInfo = item.account;
                    this.pmUsername = item.pmUsername;
                    this.additionalInfo = item.additionalInfo;
                    this.physicalBuilding = item.physicalBuilding;
                    this.buildingOccupancy = item.buildingOccupancy;
                    this.parking = item.parking;
                    this.parkingGFA = item.parkingGFA;
                    this.propertyDetail = temp;
                    this.address = item.address;
                    this.postalCode = item.postalCode;
                }
            },
            getPropertyInfo() {
                let propertyInfo = this.$store.getters.PROPERTYLIST;

                if (propertyInfo.length > 1) {
                    let data = propertyInfo;

                    this.propertyInfo = data;
                    //this.propertyType = propertyInfo[propertyInfo.length - 1].index;
                }
                else if (propertyInfo.length === 1) {
                    let data = propertyInfo[0];

                    let index = propertyInfo[propertyInfo.length - 1].index;
                    this.propertyType = index;

                    this.button_label = "Update building";
                    this.getPropertyDetail(data, index);
                }
            },
            onChange: function (event) {
                let index = event.target.value;

                let property = this.$store.getters.PROPERTYDETAIL;
                let data = property[index];
                data.index = index;
                data.propertytype = data[0].question;
                data.propertydesc = data[1].question;
                this.accountInfo = [];

                this.getPropertyDetail(data, index);
            },
            prevpage() {
                this.$router.push({ name: 'Contact', params: { parameters: this.contact } });
            },
            nextpage() {
                let proceed = this.addPropertyDetail();

                if (proceed) {
                    let propertyInfo = this.$store.getters.PROPERTYLIST;

                    this.propertyInfo = propertyInfo;
                    
                    this.propertyType = "-1";
                    this.pmUsername = "";
                    this.physicalBuilding = "";
                    this.buildingOccupancy = "";
                    this.parking = "No";
                    this.parkingGFA = "";
                    this.additionalInfo = "";
                    this.edit_data = false;
                    this.address = "";
                    this.postalCode = "";
                }
            },
            enablesummarypage() {
                //this.$store.dispatch("SAVE_PROPERTYLIST", this.propertyDetail);
                let proceed = true;
                let nextPage = "HydroAgreement";
                if (this.hasAccount || this.summaryPage)
                    nextPage = "Summary";
                    
                if (this.propertyType > -1)
                    proceed = this.addPropertyDetail();

                if (proceed)
                    this.$router.push({ name: nextPage, params: { parameters: this.contact } });
            },
            addPropertyDetail() {
                let data = this.propertyDetail;
                if (!this.hasAccount) {
                    for (let i = 0; i < data.length; i++) {
                        let q = data[i].question;
                        let a = data[i].answer;
                        if ((q.indexOf("*") !== -1 || q.indexOf("require") !== -1) && a === "") {
                            alert("\"" + q + "\" is mandatory.");
                            return false;
                        }
                    }
                }
                else {
                    if (this.address === "" || typeof(this.address) === "undefined") {
                        alert("Building address is mandatory.");
                        return false;
                    }
                    if (this.postalCode === "" || typeof(this.postalCode) === "undefined") {
                        alert("Postal code is mandatory.");
                        return false;
                    }
                    if (this.pmUsername === "" || typeof(this.pmUsername) === "undefined") {
                        alert("Portfolio Manager Username is mandatory.");
                        return false;
                    }
                }
                if (this.hasAccount === false) {
                    if ((this.accountNumber === "" || typeof (this.accountNumber) === "undefined") && typeof (this.accountInfo) === "undefined") {
                        alert("Manitoba Hydro account number is mandatory.");
                        return false;
                    }
                    if (this.hydroNumber !== "" || this.gasNumber !== "" || this.accountNumber !== "")
                        this.addAccountInfo();

                    if (typeof (this.accountInfo) === "undefined") {
                        alert("Please enter at least one Manitoba Hydro account number.");
                        return false;
                    }
                }

                //data.unshift( {question: data.propertydesc, answer: ""});
                //data.unshift( {question: data.propertytype, answer: ""});
                data.push({
                    account: this.accountInfo, pmUsername: this.pmUsername, physicalBuilding: this.physicalBuilding,
                    buildingOccupancy: this.buildingOccupancy, parking: this.parking,
                    parkingGFA: this.parkingGFA, additionalInfo: this.additionalInfo,
                    hasAccount: this.hasAccount, address: this.address,
                    postalCode: this.postalCode
                });

                if (this.button_label === "Add another building")
                    this.$store.dispatch("SAVE_PROPERTYLIST", data);
                else {
                    //let index = this.propertyType;

                    let value = { detail: data, index: this.rowNumber };

                    this.$store.dispatch("EDIT_PROPERTYLIST", value);

                    this.button_label = "Add another building";
                }

                return true;
            },
            addAccountInfo() {
                if (typeof (this.accountInfo) === "undefined")
                    this.accountInfo = [];
                this.accountInfo.push({ accountNumber: this.accountNumber, hydroNumber: this.hydroNumber, gasNumber: this.gasNumber });
                this.accountNumber = "";
                this.hydroNumber = "";
                this.gasNumber = "";
            },
            deleteHydro(index) {
                this.accountInfo.splice(index);
            },
            getPropertyName(data) {
                if (typeof (data) !== "undefined") {
                    return data[0].question;
                }
                return "";
            },
            infoclicked: function (question) {
                window.open('https://portfoliomanager.energystar.gov/pm/glossary#' + question.trim().charAt(0));
            },
        }
    }
</script>